import { Box } from "@mui/material";
import React, { useEffect } from "react";
import EditSkillMainInfo from "./components/editSkill";
import EditDescription from "./components/editDescription";
import { useTheme } from "../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  resetSkillData,
  updateSkillData,
} from "../../../../../store/slices/profile/skillSlice";
import useProtectedAuth from "../../../../../hooks/useProtectedAuth";
import { node_server } from "../../../../../constants";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { setActiveUserSkill } from "../../../../../store/slices/userSlice";
import Loading from "../../../../../components/loading/default";
import { setIsPageLoading } from "../../../../../store/slices/loadingSlice";
import Popup from "../../../../../components/common/popup";
import { NotFound as SkillNotFound } from "../../../../../components/common/notFound";
import { updateNotFound } from "../../../../../store/slices/infoSlice";

const SkillDetails = () => {
  useProtectedAuth();
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { value: user, activeUserSkill } = useSelector((state) => state.user);
  const { pageLoading } = useSelector((state) => state.isLoading);
  const { id } = useParams();
  const { isOpen } = useSelector((state) => state.info.notFound);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!user) return;
    dispatch(updateSkillData({ ...activeUserSkill }));
  }, [activeUserSkill]);

  useEffect(() => {
    if (!user) return;
    const fetchSkill = async () => {
      dispatch(setIsPageLoading(true));
      const { data, error } = await axios.get(
        `${node_server}/api/skills/${id}`,
        {
          withCredentials: true,
        }
      );

      if (error) console.log(error);
      if (data) {
        if (data.message === "Skill not found") {
          dispatch(
            updateNotFound({
              isOpen: true,
              heading: "Skill not found",
              body: "You are not authorized to edit this skill",
            })
          );
        } else {
          dispatch(setActiveUserSkill(data));
        }
        dispatch(setIsPageLoading(false));
      }
    };

    if (id && !activeUserSkill) {
      fetchSkill();
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const fetchSkills = async () => {
      dispatch(setIsPageLoading(true));
      const { data, error } = await axios.get(
        `${node_server}/api/user/skills`,
        {
          withCredentials: true,
        }
      );

      if (error) console.log(error);
      if (data) {
        const count = data.length;
        if (count === 3) {
          dispatch(
            updateNotFound({
              heading: "You cannot add another skill",
              body: "You have reached your maximum number of skills. Each user has only 3 skills to add",
              isOpen: true,
            })
          );
        }
      }
      dispatch(setIsPageLoading(false));
    };

    if (pathname.includes("add-skill")) {
      dispatch(resetSkillData());
      fetchSkills();
    }
  }, [user]);

  if (pageLoading) return <Loading />;

  return (
    <Box
      style={{ paddingBottom: "5rem" }}
      sx={{ bgcolor: theme.palette.lightgrey.lightgrey00 }}
    >
      <SkillNotFound />
      <Popup />
      {!isOpen && (
        <>
          <EditSkillMainInfo />
          <EditDescription />
        </>
      )}
    </Box>
  );
};

export default SkillDetails;
